import { combineReducers, configureStore } from '@reduxjs/toolkit';

import {
  personalAreaReducer,
  appReducer,
  notificationsReducer,
  settingsReducer,
  requestsReducer,
  employeesReducer,
} from 'store';
import { apiService, newsApi } from 'services';

const rootReducer = combineReducers({
  app: appReducer,
  personalArea: personalAreaReducer,
  notifications: notificationsReducer,
  settings: settingsReducer,
  requests: requestsReducer,
  employees: employeesReducer,
  [apiService.reducerPath]: apiService.reducer,
  [newsApi.reducerPath]: newsApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiService.middleware, newsApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
